module.exports = __webpack_public_path__ + "static/media/industry_icon.bb024e61.svg";